export const realtimeRefreshMs = 25 * 60 * 1000;
export const realtimeReuseMs = 30 * 60 * 1000;
export const realtimeLifetimeMs = 60 * 60 * 1000;
